<template>
    <div class="page" ref="container">
        <div class="banner-wrap">
            <div class="banner">
                <div class="swipe-wrap">
                    <van-swipe :autoplay="3000" indicator-color="white" width="100%" ref="banner">
                        <van-swipe-item v-for="(banner, b) in banners" :key="b">
                            <van-image
                                width="100%"
                                height="100%"
                                fit="cover"
                                :src="banner.url"
                                :alt="banner.name"
                            />
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>
        </div>
        <div class="content-wrap wrap">
            <div class="bulletin">
                <div class="left">
                    <img src="@images/bulletin-left-bg.png" alt="bulletin" />
                </div>
                <div class="right">
                    <van-swipe vertical :show-indicators="false" :autoplay="5000">
                        <van-swipe-item v-for="(article, a) in bulletins" :key="a">
                            <router-link :to="article.url">{{ article.title }}</router-link>
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>
            <van-tabs v-model="active" title-active-color="#333">
                <van-tab v-for="(cate, c) in cates" :title="cate.name" :key="c"></van-tab>
            </van-tabs>
            <div class="lists">
                <div class="items">
                    <router-link
                        :to="'/classes/' + item.id"
                        class="item"
                        v-for="(item, i) in lists"
                        :key="i"
                    >
                        <div class="image">
                            <van-image :src="item.thumb" fit="cover" />
                        </div>
                        <div class="name">{{ item.name }}</div>
                        <div class="time">
                            报名时间：{{ item.start_time_text }}-{{ item.end_time_text }}
                        </div>
                        <div class="tips" :class="'status-' + item.apply_status"></div>
                    </router-link>
                </div>
                <van-loading v-if="!loaded">
                    加载中...
                </van-loading>
                <van-empty
                    :image="require('@images/nodata.png')"
                    description="暂无任何班级"
                    v-if="lists.length === 0 && !loading"
                />
            </div>
            <div class="venue-reserve">
                <div class="left">
                    <div class="title">场馆预约入口</div>
                    <div class="desc">线上申请 方便快捷</div>
                </div>
                <van-button type="primary" to="/venue">去预约</van-button>
            </div>
        </div>
    </div>
</template>
<script>
import { getHomeData } from '@api/public';
import { getClassesCate, getClassesLists } from '@api/classes';
import { mapGetters } from 'vuex';

export default {
    name: 'Index',
    data: function() {
        return {
            banners: [],
            bulletins: [],
            cates: [],
            active: 0,
            lists: [],
            where: {
                cid: 0,
                page: 1,
                limit: 12
            },
            loaded: false,
            loading: false
        };
    },
    created() {
        this.getHomeData();
        this.getClassesCategory();
    },
    watch: {
        $route(n) {
            if (n.name === 'Index') {
                this.getHomeData();
                if (this.cates.length > 0) {
                    this.$set(this.where, 'cid', this.cates[this.active].id);
                    this.where.page = 1;
                    this.loaded = false;
                    this.loading = false;
                    this.$set(this, 'lists', []);
                    this.getLists();
                }
            }
        },
        active: function() {
            this.$set(this.where, 'cid', this.cates[this.active].id);
            this.where.page = 1;
            this.loaded = false;
            this.loading = false;
            this.$set(this, 'lists', []);
            this.getLists();
        }
    },
    computed: {
        ...mapGetters(['isLogin'])
    },
    mounted: function() {
        this.$scroll(this.$refs.container, () => {
            !this.loading && this.getLists();
        });
    },
    methods: {
        getHomeData() {
            let that = this;
            getHomeData().then(res => {
                that.$set(that, 'banners', res.data.banners);
                that.$set(that, 'bulletins', res.data.bulletins);
            });
        },
        getClassesCategory() {
            let that = this;
            getClassesCate().then(res => {
                that.$set(that, 'cates', res.data);
                if (res.data.length > 0) {
                    that.$set(that.where, 'cid', res.data[0].id);
                    that.getLists();
                }
            });
        },
        getLists() {
            let that = this;
            if (that.loaded == true || that.loading == true) return;
            this.loading = true;
            getClassesLists(this.where)
                .then(res => {
                    that.loading = false;
                    that.lists.push.apply(that.lists, res.data);
                    that.loaded = res.data.length < that.where.limit;
                    that.where.page = that.where.page + 1;
                })
                .catch(err => {
                    return that.$dialog.error(err);
                });
        }
    }
};
</script>
